import { CovanceFilterBaseType } from '../covance-filter-base-type';
import { AgeFilter, FilterFieldValue } from '../../covance-filter.models';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isEmpty } from 'lodash';

export interface AgeOperator {
    readonly title: string;
    readonly value: string;
}

export const allowedAgeOperators: ReadonlyArray<AgeOperator> =
    Object.freeze([
        {
            title: '>',
            value: 'More',
        },
        {
            title:  '<',
            value: 'Less'
        },
        {
            title: '=',
            value: 'Equal'
        }
    ]);

@Injectable()
export class CovanceFilterAgeType extends CovanceFilterBaseType {
    private readonly separator = 'Then';
    private readonly operatorRegexValues = allowedAgeOperators.map(x => `'${x.value}'`).join(', ');
    private readonly operator = new RegExp(`([${this.operatorRegexValues}]+?)${this.separator}`);
    private readonly day = new RegExp(`${this.separator}(\\d+?)$`);
    constructor(router: Router, route: ActivatedRoute) {
        super(router, route);
    }

    public setValue(fieldVal: FilterFieldValue) {
        fieldVal.value = this.parseQueryString(fieldVal.queryParamValue);
    }

    public setQueryParamValue(fieldVal: FilterFieldValue) {
        fieldVal.queryParamValue = !isEmpty(fieldVal.value.operator)
            && !isEmpty(fieldVal.value.day) ?
                `${fieldVal.value.operator}Then${fieldVal.value.day}` : '';
    }

    public isMatch(fieldVal: FilterFieldValue, value: any): boolean {
        return false;
    }

    public serializeValue(value: any): string {
        return '';
    }

    private parseQueryString(value: string): AgeFilter {
        if (!value) {
            return null;
        }

        const filter = new AgeFilter(null, null);

        const op = this.operator.exec(value);
        const day = this.day.exec(value);
        filter.operator = op && op[1];
        filter.day = day && day[1];

        return filter;
    }

}
